// ── 미팅지도 설정: 미팅인계 담당자 토글 패널 ─────────────────────────────────
// 동적관리 PersonsAndWorkflowSection 의 미팅인계 블록 이식 (2026-09-01 설정 이관).
// personChip/dot 팩토리도 함께 이동 (동적관리 classNames.js 에서 제거됨).
import React from 'react';
import { cn } from '../../../lib/utils';

// 미팅인계 담당자 칩 className (eligible: 활성화 여부)
function personChip(eligible) {
  return cn(
    'inline-flex items-center gap-1.5 border rounded-full px-3 py-[5px] text-xs font-bold cursor-pointer transition-colors duration-100 bg-transparent',
    eligible
      ? 'bg-accent-50 border-accent-400 text-accent-700 dark:bg-pine-800 dark:border-accent-500 dark:text-accent-300'
      : 'border-[var(--border)] text-[var(--text-muted)]',
  );
}

// 미팅인계 담당자 상태 점 className
function dot(eligible) {
  return cn('w-1.5 h-1.5 rounded-full flex-shrink-0', eligible ? 'bg-accent-500' : 'bg-slate-300 dark:bg-slate-600');
}

export function SettingsInheritPanel({ inheritPersons, inheritLoading, toggleInheritPerson }) {
  return (
    <div className="grid gap-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[12px] font-extrabold text-[var(--text)]">미팅인계 담당자</span>
        <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-[var(--bg-subtle)] text-[var(--text-muted)]">
          {inheritPersons.filter((p) => p.is_eligible).length}명 활성
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5 items-center">
        {inheritLoading && <span className="text-xs text-[var(--text-muted)] py-0.5">불러오는 중...</span>}
        {!inheritLoading && inheritPersons.length === 0 && (
          <span className="text-xs text-[var(--text-muted)] py-0.5">마케팅 담당자가 없습니다.</span>
        )}
        {!inheritLoading && inheritPersons.map((p) => (
          <button key={p.id} className={personChip(p.is_eligible)} onClick={() => toggleInheritPerson(p)}
            title={p.is_eligible ? '클릭하면 비활성화' : '클릭하면 활성화'}>
            <span className={dot(p.is_eligible)} />
            {p.name}
          </button>
        ))}
      </div>
      <div className="text-[11px] text-[var(--text-muted)] leading-relaxed">
        활성화된 담당자만 미팅 결과 입력 모달의 미팅인계 대상으로 표시됩니다.
      </div>
    </div>
  );
}
